module.exports = __webpack_public_path__ + "img/num.d6481e6a.png";